import React from 'react';
import './DiscountCouponCard.css'
import { CopyToClipboard, CopiedToClipbard } from '../../assets';

export interface DiscountCoupon {
  couponCode: string;
  formattedCouponExpirationDate: string;
  discountValue?: number;
  discountPercentage?: number;
}

export interface DiscountCouponCardProps {
  discountCoupon: DiscountCoupon;
  onCopy: (result: boolean) => void;
}

export const DiscountCouponCard = ({
  discountCoupon,
  onCopy
}: DiscountCouponCardProps) => {

  const [couponCodeCopied, setCouponCodeCopied] = React.useState(false);

  const discountValue = discountCoupon.discountValue || 0;
  const discountPercentage = discountCoupon.discountPercentage || 0;
  let discount = '';
  if (discountValue > 0 || discountPercentage > 0) {
    discount = discountValue > 0
      ? `R$${discountValue.toFixed(0)} off`
      : `${discountPercentage.toFixed(0)}% off`;
  }

  return (
    <button className='discount-coupon-card' onClick={handleCopyCouponCodeToClipboard}>
      <div className='discount-coupon-card--discount'>
        {discount}
      </div>
      <div className='discount-coupon-card--expiration'>
        valido até {discountCoupon.formattedCouponExpirationDate}
      </div>
      {couponCodeCopied ? (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={CopiedToClipbard} alt="Cupom copiado" style={{ width: '24px', height: '24px' }} />
          <span style={{ marginLeft: '0.2rem', fontSize: '0.75em' }}>cupom copiado</span>
        </div>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={CopyToClipboard} alt="Copiar cupom" style={{ width: '24px', height: '24px' }} />
          <span style={{ marginLeft: '0.2rem', fontSize: '0.75em' }}>copiar cupom</span>
        </div>
      )}
    </button>
  )

  function handleCopyCouponCodeToClipboard() {
    setCouponCodeCopied(false);

    navigator.clipboard.writeText(discountCoupon.couponCode)
      .then(() => {
        setCouponCodeCopied(true);
        setTimeout(() => {
          setCouponCodeCopied(false);
        }, 3000);
      })
      .catch(() => {
        onCopy && onCopy(false);
      });
  }
}